// import Dyn from '../../lib/dynDataSet/dynMiscellany';
import ModelFunctions from './ModelFunctions.jsx'
import PlainButton from '../common/PlainButton';
import React from 'react';

class ModelFunctionsWrapper extends React.Component {
    handleClose = () => {
        this.props.onClose();
    }

    state = {
        modelFunctionsIds: []
    }

    UNSAFE_componentWillMount = () => {
        let Dyn = this.props.Dyn,
            modelFunctionsIds = [];

        // Refill modelFunctionsIds from saved object
        if(Dyn['deFormulas'] && Object.keys(Dyn['deFormulas']).length > 0) {
            Object.keys(Dyn['deFormulas']).forEach((key) => {
                let intKey = parseInt(key);
                Dyn.assert( modelFunctionsIds.indexOf(intKey)===-1, "Not a unique ID, undo/redo may change wrong function:"+intKey );
                modelFunctionsIds.push(intKey);
            });
        } else {
            modelFunctionsIds = [this.props.Dyn.FunctionUtil.getNextFunctionID()];
        }

        this.setState({
            modelFunctionsIds: modelFunctionsIds,
            xAttribute: Dyn.plotView.xAxis.allAttributes.type === 1? Dyn.plotView.xAxis.allAttributes.name: '',
            yAttribute: Dyn.plotView.yAxis.allAttributes.type === 1? Dyn.plotView.yAxis.allAttributes.name: '',
        });

        this.subscriptions = [];

        // remove attribute name from model functions panel when removed from plot axis
        Dyn.mediatorLocalSubscribe( this.subscriptions, "records:setRemovedAttribute", (data) => {
            setTimeout(() => {
                this.setState({
                    xAttribute: Dyn.plotView.xAxis.allAttributes.type === 1? Dyn.plotView.xAxis.allAttributes.name: '',
                    yAttribute: Dyn.plotView.yAxis.allAttributes.type === 1? Dyn.plotView.yAxis.allAttributes.name: ''
                });
            }, 100);
        });
        // add attribute name from model functions panel when added to plot (possible during undo/redo add/remove attribute only)
        Dyn.mediatorLocalSubscribe( this.subscriptions, "records:setAddedAttribute", (data) => {
            setTimeout(() => {
                this.setState({
                    xAttribute: Dyn.plotView.xAxis.allAttributes.type === 1? Dyn.plotView.xAxis.allAttributes.name: '',
                    yAttribute: Dyn.plotView.yAxis.allAttributes.type === 1? Dyn.plotView.yAxis.allAttributes.name: ''
                });
            }, 100);
        });

        Dyn.mediatorLocalSubscribe( this.subscriptions, "plot:restoreFormulas", ( data ) => {
            setTimeout(() => {
                this.handleRestore( data );
            }, 100 );
        });
    }

    componentWillUnmount() {
        this.props.Dyn.mediatorLocalRemoveAll( this.subscriptions );
        //console.log("Unmounted fx wrapper" );
    }

    // To listen the keypress on the component
    onKeyPressed = (e) => {
        if(e.keyCode === 27) {
            // Focus close button on esc
            this.refs.closeButton.focus();
        }
    }

    getLoc = (str) => {
        let Dyn = this.props.Dyn;
        if(Dyn.dataSet) {
            return Dyn.loc( str );
        } else {
            return str;
        }
    }

    /** add a new subpanel */
    onAdd = () => {
        let Dyn = this.props.Dyn,
            id = this.props.Dyn.FunctionUtil.getNextFunctionID(); // must be unique for undo/redo
        Dyn.assert( this.state.modelFunctionsIds.indexOf(id)===-1, "Not a unique ID, undo/redo may change wrong function:"+id );

        // add the ID to modelFunctionIds array the ReactJS way: copy,modify,set
        this.setState(prevState => ({
            modelFunctionsIds: [...prevState.modelFunctionsIds, id]
        }));
    };

    /** handle close of a model function by removing it from our list */
    handleModelFunctionEleClose = (modelFunctionId) => {
        let Dyn = this.props.Dyn;
        // remove ID from modelFunctionIds array the ReactJS way: copy,modify,set
        Dyn.assert( this.state.modelFunctionsIds.indexOf(modelFunctionId) >= 0 );
        this.setState(prevState => ({
            modelFunctionsIds: prevState.modelFunctionsIds.filter( id => id !== modelFunctionId )
        }));
    };

    /**
     *  handle restore after save/restore/undo/redo; panels are added and removed as needed
     *  the saved data in Dyn.deFormulas has already been restored
     */
    handleRestore = ( data ) => {
        let Dyn = this.props.Dyn;
        // restore IDs in modelFunctionIds array the ReactJS way: copy,modify,set
        this.setState( prevState => {
            let modelFunctionsIds = [...prevState.modelFunctionsIds]; // copy
            // remove any panels that are not in restored data
            for( let i = modelFunctionsIds.length - 1; i >= 0; i-- ) {
                let id = modelFunctionsIds[i],
                    d  = Dyn.deFormulas[id];
                if( !d ) {
                    console.log( "ModelFunctionsWrapper.handleRestore remove panel", id );
                    modelFunctionsIds.splice( i, 1 );
                }
            }
            // add missing panels, if any
            for( var key in Dyn.deFormulas ) {
                let id = Number( key );
                if( !modelFunctionsIds.includes( id ) ) {
                    console.log( "ModelFunctionsWrapper.handleRestore insert panel", id );
                    let index = modelFunctionsIds.findIndex( el => el > id );
                    if( index === -1 ) {
                        modelFunctionsIds.push( id ); // add to end, it is the highest ID number
                    } else {
                        modelFunctionsIds.splice( index, 0, id ); // add before higher ID numbers
                    }
                }
            }
            // Note: existing panels will handle their own restore in ModelFunctions.handleRestore()
            return { modelFunctionsIds: modelFunctionsIds };
        });
    };

    render = () => {
        return (
            <div className="tde-fill" onKeyDown={this.onKeyPressed} tabIndex="0" style={this.props.style}>
                <div className="tde-sliding-panel-header tde-divider-bottom">
                    {/* <PlainButton title="Add" onClick={this.onAdd} style={{left: '15px', right: 'auto'}}><i className="glyphicon glyphicon-plus"></i></PlainButton> */}
                    <div>
                        <span
                            className="tde-ml-2 tde-h6 tde-font-weight-bold"
                            role="heading"
                            aria-level="1">{ this.getLoc('MODELING CARD') }</span>
                    </div>
                    <PlainButton ref="closeButton" title="Close" aria-label={this.getLoc('Close Modeling Card')} onClick={this.handleClose} className="tde-mx-2 tde-close-attr-settings">
                        <i className="tde-i tde-i-remove"></i>
                    </PlainButton>
                </div>
                <div className="tde-sliding-panel-body tde-model-functions-body tde-card-content-bg-color">
                    { this.state.modelFunctionsIds.map((modelFunctionsId, i) => {
                        return <ModelFunctions
                            toolsContainer={this.props.toolsContainer}
                            Dyn = {this.props.Dyn}
                            xAttribute = {this.state.xAttribute}
                            yAttribute = {this.state.yAttribute}
                            reduceCaseCardWidth = {this.props.reduceCaseCardWidth}
                            key={modelFunctionsId} no={i+1} modelFunctionId={modelFunctionsId} handleClose={this.handleModelFunctionEleClose}/>
                    })}
                    <div className={this.props.reduceCaseCardWidth ? 'tde-px-2':'tde-px-3'}>
                        <div className="tde-mt-3" aria-label='Modeling Documentation link'>
                            <a href="https://support.tuvalabs.com/hc/en-us/sections/360001507313-Linear-and-Non-linear-Modeling" aria-label={this.getLoc('Learn more about how to use the modeling feature to create equations that model your data')} target="_blank" className="tde-s1 tde-font-weight-regular tde-docs-link tde-cell-subtext">
                            <i className="tde-i tde-i-help tde-mr-1"></i> {this.getLoc('Modeling Documentation')}</a>
                        </div>
                        <button title="Add New Function" aria-label={this.getLoc('Add New Function')} style={{display: 'inline-block'}} onClick={this.onAdd} className={"tde-btn tde-font-weight-bold tde-mt-4 tde-mb-0" + (this.props.reduceCaseCardWidth ? ' tde-px-3':' tde-px-4')}>
                           {this.getLoc('Add New Function')}
                        </button>
                    </div>
                </div>
            </div>
        )
    }
}

export default ModelFunctionsWrapper;
